export default [
  {
    title: 'Products & Services',
    icon: 'urn.svg',
    customIcon: true,
    children: [
      {
        title: 'Suites & Lots',
        route: 'products-suites-index',
        icon: 'dashboard-black.svg',
        customIcon: true,
        resource: 'Suite',
        action: 'read',
        parent: 'products',
      },
      {
        title: 'Locations',
        route: 'products-locations-index',
        icon: 'MapPinIcon',
        resource: 'SuiteLocation',
        action: 'read',
        parent: 'products',
      },
      {
        title: 'Areas',
        route: 'products-areas-index',
        icon: 'map.svg',
        customIcon: true,
        resource: 'SuiteArea',
        action: 'read',
        parent: 'products',
      },
    ],
  },
]
